<template>
  <div class="search-container flex align-center">
    <el-input
      class="search-email"
      v-model="email"
      clearable
      placeholder="Enter your email"
      @keyup.enter.native="handleChangeCourses"
    >
    </el-input>
    <button @click="handleChangeCourses" class="btn-search">
      Subscribe
    </button>
  </div>
</template>
<script>
import { isEmpty } from "@/utils/validate";
export default {
  name: "SearchEmail",
  props: {
    tag: {
      type: String,
      default: "span"
    }
  },
  data() {
    return {
      email: null,
      loading: false,
      options: []
    };
  },
  methods: {
    handleChangeCourses() {
    },
    remoteMethod(query) {}
  }
};
</script>
<style>
.search-email .el-input__inner {
  min-height: 40px;
  border-radius: 50px !important;
  max-width: 400px;
  width: 100%;
  padding-right: 110px !important;

}
.search-email .el-input__suffix {
  right: 85px;
}
.search-nav-bar .el-input__inner::placeholder {
  font-size: 14px;
}
</style>
<style scoped>
.search-container {
  max-width: 400px;
  width: 100%;
  position: relative;
}
.btn-search {
  margin-right: 3px;
  position: absolute;
  background: #035ae0;
  right: 0;
  color: #ffff;
  border-radius: 50px;
  font-size: 12px;
  padding: 5px 15px;
}
</style>
